function playback(backendAxiosInstance) {
  function playbackStreaming(playbackStreamingParams) {
    return backendAxiosInstance.post(
      "/experiences/v4/playback/streaming",
      playbackStreamingParams,
      {
        includeTimeZone: true,
        includeClientType: true
      }
    );
  }
  function playbackStop(playbackStopParams) {
    return backendAxiosInstance.post(
      "/experiences/v4/playback/stop",
      playbackStopParams,
      {
        includeTimeZone: true,
        includeClientType: true,
        fetchOptions: {
          keepalive: true
        }
      }
    );
  }
  function playbackProgramCompletion(playbackStopParams) {
    return backendAxiosInstance.post(
      "/experiences/v4/playback/programCompletion",
      playbackStopParams,
      {
        includeTimeZone: true,
        includeClientType: true,
        fetchOptions: {
          keepalive: true
        }
      }
    );
  }
  return {
    playbackStop,
    playbackStreaming,
    playbackProgramCompletion
  };
}

export { playback as default };
//# sourceMappingURL=playback.js.map
